type AppType = 'admin' | 'client';
type RouteType = 'login' | 'register' | 'dashboard' | 'home';

interface AppRoutes {
	ADMIN: {
		BASE: string;
		LOGIN: string;
		DASHBOARD: string;
		HOME: string;
	};
	CLIENT: {
		BASE: string;
		LOGIN: string;
		DASHBOARD: string;
		HOME: string;
		REGISTER: string;
	};
}

export const createGetAppUrl = (routes: AppRoutes) => {
	return (app: AppType, route: RouteType): string => {
		switch (app) {
			case 'admin':
				switch (route) {
					case 'login':
						return routes.ADMIN.LOGIN;
					case 'dashboard':
						return routes.ADMIN.DASHBOARD;
					case 'home':
						return routes.ADMIN.BASE;
					default:
						return routes.ADMIN.BASE;
				}
			case 'client':
				switch (route) {
					case 'login':
						return routes.CLIENT.LOGIN;
					case 'register':
						return routes.CLIENT.REGISTER;
					case 'dashboard':
						return routes.CLIENT.DASHBOARD;
					case 'home':
						return routes.CLIENT.BASE;
					default:
						return routes.CLIENT.BASE;
				}
			default:
				return routes.CLIENT.BASE;
		}
	};
};
